import type { SectionTag, Tag } from "@/App/types/twiageTypes";
import type { TwiageCase } from "@/App/types/TwiageCase";

export const tagsBySection = (tags: Tag[]): SectionTag[] => {
  const sections: SectionTag[] = [];

  tags.forEach((tag: Tag) => {
    const i = sections.findIndex((e) => e.section === tag.type?.toUpperCase());
    if (i > -1) {
      sections[i].tags.push(tag);
    } else {
      sections.push({
        section: tag.type?.toUpperCase() ?? "Section Unknown",
        tags: [tag],
      });
    }
  });
  return sections;
};

export const populateCase = (twiageCase: TwiageCase): TwiageCase => {
  replaceUndefinedWithEmptyArrays({ object: twiageCase, fields: ["activatedProtocols", "uploads"] });
  return twiageCase;
};
const replaceUndefinedWithEmptyArrays = ({
  object,
  fields,
}: {
  object: Record<string, unknown>;
  fields: string[];
}): void => {
  fields.forEach((field) => {
    if (object[field] === undefined) {
      object[field] = [];
    }
  });
};

export const getDateISOString = (): string => new Date().toISOString();

export const isCaseALS = (twiageCase: TwiageCase): boolean => {
  const alsOnBoardIndex = twiageCase.tags
    ? twiageCase.tags.findIndex((tag) => tag && tag.name && tag.name.toLowerCase().includes("als on board"))
    : -1;
  return twiageCase.truck?.isALS || alsOnBoardIndex > -1;
};
